import { render, staticRenderFns } from "./Toolbox.vue?vue&type=template&id=323cdcbb&scoped=true&"
import script from "./Toolbox.vue?vue&type=script&lang=ts&"
export * from "./Toolbox.vue?vue&type=script&lang=ts&"
import style0 from "./toolbox.scss?vue&type=style&index=0&id=323cdcbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323cdcbb",
  null
  
)

export default component.exports